"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tvl = exports.withdraw = exports.deposit = exports.setHashes = exports.initializeProtocol = void 0;
const anchor_1 = require("@project-serum/anchor");
const sha256_uint8array_1 = require("sha256-uint8array");
const addressParser_1 = require("../addressParser");
const protocols_1 = require("../protocols");
const mangoKeysAll = (0, addressParser_1.addressParser)({
    group: "protocols",
    name: "mango",
});
function initializeProtocol(program) {
    return __awaiter(this, void 0, void 0, function* () {
        const tokenInput = program.tokenInput;
        const vaultKeys = program.vaultKeys[tokenInput];
        const mangoKeys = mangoKeysAll[tokenInput];
        const accountNumber = new anchor_1.BN(1);
        const [vaultMangoAccount, _bump] = yield anchor_1.web3.PublicKey.findProgramAddress([
            mangoKeys.group.toBytes(),
            vaultKeys.vaultAccount.toBytes(),
            accountNumber.toBuffer("le", 8),
        ], mangoKeys.programId);
        vaultKeys.vaultMangoAccount = vaultMangoAccount;
        if (yield program.connection.getAccountInfo(vaultMangoAccount)) {
            console.log("mango account already initialized");
            return null;
        }
        else {
            return program.methods
                .mangoInitialize()
                .accounts({
                userSigner: program.user,
                vaultAccount: vaultKeys.vaultAccount,
                vaultMangoAccount,
                mangoGroupAccount: mangoKeys.group,
                mangoProgramId: mangoKeys.programId,
                systemProgram: anchor_1.web3.SystemProgram.programId,
            })
                .transaction();
        }
    });
}
exports.initializeProtocol = initializeProtocol;
function setHashes(program) {
    return __awaiter(this, void 0, void 0, function* () {
        const tokenInput = program.tokenInput;
        const vaultKeys = program.vaultKeys[tokenInput];
        const mangoKeys = mangoKeysAll[tokenInput];
        const depositData = new Uint8Array([
            ...vaultKeys.vaultMangoAccount.toBytes(),
            ...mangoKeys.group.toBytes(),
            ...mangoKeys.cacheAccount.toBytes(),
            ...mangoKeys.rootBankAccount.toBytes(),
            ...mangoKeys.nodeBankAccount.toBytes(),
            ...mangoKeys.vaultAccount.toBytes(),
        ]);
        const withdrawData = new Uint8Array([
            ...vaultKeys.vaultMangoAccount.toBytes(),
            ...mangoKeys.cacheAccount.toBytes(),
            ...mangoKeys.group.toBytes(),
            ...mangoKeys.groupSignerAccount.toBytes(),
            ...mangoKeys.rootBankAccount.toBytes(),
            ...mangoKeys.nodeBankAccount.toBytes(),
            ...mangoKeys.vaultAccount.toBytes(),
        ]);
        const tvlData = new Uint8Array([
            ...vaultKeys.vaultMangoAccount.toBytes(),
            ...mangoKeys.group.toBytes(),
            ...mangoKeys.cacheAccount.toBytes(),
            ...mangoKeys.rootBankAccount.toBytes(),
        ]);
        const HASH_LEN = 16;
        const hashes = [
            (0, sha256_uint8array_1.createHash)().update(depositData).digest().slice(0, HASH_LEN),
            (0, sha256_uint8array_1.createHash)().update(withdrawData).digest().slice(0, HASH_LEN),
            (0, sha256_uint8array_1.createHash)().update(tvlData).digest().slice(0, HASH_LEN),
        ];
        return program.methods
            .setHashes(protocols_1.Protocols.Mango, hashes)
            .accounts({
            userSigner: program.user,
            vaultAccount: vaultKeys.vaultAccount,
        })
            .transaction();
    });
}
exports.setHashes = setHashes;
function deposit(program, genericAcccounts) {
    return __awaiter(this, void 0, void 0, function* () {
        const tokenInput = program.tokenInput;
        const vaultKeys = program.vaultKeys[tokenInput];
        const mangoKeys = mangoKeysAll[tokenInput];
        return program.methods
            .mangoDeposit()
            .accounts({
            genericAccs: genericAcccounts,
            mangoProgramId: mangoKeys.programId,
            vaultMangoAccount: vaultKeys.vaultMangoAccount,
            mangoGroupAccount: mangoKeys.group,
            mangoCacheAccount: mangoKeys.cacheAccount,
            mangoRootBankAccount: mangoKeys.rootBankAccount,
            mangoNodeBankAccount: mangoKeys.nodeBankAccount,
            mangoVaultAccount: mangoKeys.vaultAccount,
        })
            .transaction();
    });
}
exports.deposit = deposit;
function withdraw(program, genericAcccounts) {
    return __awaiter(this, void 0, void 0, function* () {
        return withdrawBuilder(program, genericAcccounts).transaction();
    });
}
exports.withdraw = withdraw;
function withdrawBuilder(program, genericAcccounts) {
    const tokenInput = program.tokenInput;
    const vaultKeys = program.vaultKeys[tokenInput];
    const mangoKeys = mangoKeysAll[tokenInput];
    return program.methods.mangoWithdraw().accounts({
        genericAccs: genericAcccounts,
        mangoProgramId: mangoKeys.programId,
        vaultMangoAccount: vaultKeys.vaultMangoAccount,
        mangoGroupAccount: mangoKeys.group,
        mangoCacheAccount: mangoKeys.cacheAccount,
        mangoGroupSignerAccount: mangoKeys.groupSignerAccount,
        mangoRootBankAccount: mangoKeys.rootBankAccount,
        mangoNodeBankAccount: mangoKeys.nodeBankAccount,
        mangoVaultAccount: mangoKeys.vaultAccount,
        systemProgram: anchor_1.web3.SystemProgram.programId,
    });
}
function tvl(program, genericAcccounts) {
    return __awaiter(this, void 0, void 0, function* () {
        const tokenInput = program.tokenInput;
        const vaultKeys = program.vaultKeys[tokenInput];
        const mangoKeys = mangoKeysAll[tokenInput];
        return program.methods
            .mangoTvl()
            .accounts({
            genericAccs: genericAcccounts,
            vaultMangoAccount: vaultKeys.vaultMangoAccount,
            mangoGroupAccount: mangoKeys.group,
            mangoCacheAccount: mangoKeys.cacheAccount,
            mangoRootBankAccount: mangoKeys.rootBankAccount,
            defaultPubkey: anchor_1.web3.PublicKey.default,
        })
            .transaction();
    });
}
exports.tvl = tvl;
//# sourceMappingURL=mango.js.map